import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { ApolloProvider } from '@apollo/react-hooks';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import DatadogHandler from 'utils/datadog';
import Auth0ProviderWithHistory from 'auth/auth0-provider-with-history';
import reducerMap from './redux/reducers';
import App from './components/App';
import apolloUtils from './utils/apolloUtils';
import { initializeTracking } from './utils/trackingUtils';
import { initFreshchat } from './utils/initFreshchat';
import { initGTM } from './utils/initGTM';

import './i18n';
import SplitReactSDK, { SplitReact } from './split.sdk';

// initialise Datadog
DatadogHandler.init();
SplitReactSDK.init();

const initalState = {};
const str = localStorage.getItem('authUser');

if (str) {
  initalState.authUser = JSON.parse(str);
}

// initializes google analytics tracking
initializeTracking();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducerMap,
  initalState,
  composeEnhancers(applyMiddleware(thunk))
);
window.gSkoolstore = store;

const apolloClient = apolloUtils();
const queryClient = new QueryClient();

initFreshchat();
initGTM();
const AppRoute = () => (
  <Provider store={store}>
    <ApolloProvider client={apolloClient}>
      <BrowserRouter>
        <Auth0ProviderWithHistory>
          <SplitReact>
            <QueryClientProvider client={queryClient}>
              <App />
            </QueryClientProvider>
          </SplitReact>
        </Auth0ProviderWithHistory>
      </BrowserRouter>
    </ApolloProvider>
  </Provider>
);

ReactDOM.render(<AppRoute />, document.getElementById('app-container'));
